import React, { useEffect } from "react";
import { Attestation } from "model/attestion.model";
import { connect } from "react-redux";
import { GlobalState } from "store/configure-store";
import OverviewCard from "./OverviewCard";
import { selectCanUseHelena } from "store/reducers/helena.reducer";
import {
  createTarificationSession,
  deleteTarifiedItemAction,
} from "store/actions/tarification.actions";
import { Patient } from "model/patient.model";
import { usePrevious } from "common/hooks/previous.hook";
import { TarificationSessionKey } from "model/tarification-session-key.model";
import { ETarResult } from "model/e-tar.result";
import {
  selectAttestationRequest,
  selectEtarResult,
  selectPatient,
  selectTarificationSessionForPatient,
} from "store/reducers/patient.reducer";
import { selectUser } from "store/reducers/user-context.reducer";
import { selectTarificationApplicationSession } from "store/reducers/tarification.reducer";
import {
  CreateTarificationSessionType,
  DeleteTarifiedItemActionType,
} from "store/types/tarification.types";
import { TarifiedItem } from "model/tarified-item.model";
import { User } from "model/user.model";
import { History } from "history";
import Page from "ui/Page";
import { TarificationApplicationSession } from "model/tarification.model";
import { useTrackPageView } from "common/matomo/track-page-view.hook";
import { PV_ATTESTATION } from "common/matomo/track-page-view.constants";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  inView: boolean;
  onEditTarifiedItem: (tarifiedItem: TarifiedItem) => void;
  history: History;
}

const AttestationContainer = ({
  attestation,
  canUseHelena,
  inView,
  createTarificationSession,
  user,
  patient,
  tApplicationSession,
  tSession,
  deleteTarifiedItemAction,
  eTarResult,
  onEditTarifiedItem,
  history,
}: StateFromProps & DispatchFromProps & Props) => {
  const prevInView = usePrevious(inView);
  useEffect(() => {
    if (
      inView &&
      !prevInView &&
      tApplicationSession != null &&
      user.id > 0 &&
      patient.id > 0 &&
      attestation.dirty
    ) {
      createTarificationSession(
        tApplicationSession,
        user.id,
        patient.id,
        attestation,
        history,
        tSession
      );
    }
  }, [
    inView,
    prevInView,
    tSession,
    tApplicationSession,
    user.id,
    patient.id,
    attestation,
    createTarificationSession,
    history,
  ]);

  useTrackPageView(PV_ATTESTATION);

  return (
    <Page.Scrollable>
      <Page.Body>
        <section>
          <OverviewCard
            tSession={tSession}
            attestation={attestation}
            deleteTarifiedItem={deleteTarifiedItemAction}
            user={user}
            tApplicationSession={tApplicationSession}
            eTarResult={eTarResult}
            onEditTarifiedItem={onEditTarifiedItem}
            canUseHelena={canUseHelena}
          />
        </section>
      </Page.Body>
    </Page.Scrollable>
  );
};

interface StateFromProps {
  attestation: Attestation;
  canUseHelena: boolean;
  user: User;
  patient: Patient;
  tApplicationSession: TarificationApplicationSession;
  tSession?: TarificationSessionKey;
  eTarResult?: ETarResult;
}

const mapStateToProps = (state: GlobalState): StateFromProps => {
  return {
    attestation: selectAttestationRequest(state),
    canUseHelena: selectCanUseHelena(state.helena),
    user: selectUser(state),
    patient: selectPatient(state),
    tApplicationSession: selectTarificationApplicationSession(state),
    tSession: selectTarificationSessionForPatient(state),
    eTarResult: selectEtarResult(state),
  };
};

interface DispatchFromProps {
  deleteTarifiedItemAction: DeleteTarifiedItemActionType;
  createTarificationSession: CreateTarificationSessionType;
}

export default connect(mapStateToProps, {
  createTarificationSession,
  deleteTarifiedItemAction,
})(AttestationContainer);
